const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            backgroundColor: {
                type: 'string',
            },
            borderRadius: {
                type: 'number',
            },
            borderColor: {
                type: 'string',
            },
            borderWidth: {
                type: 'number',
            },
            height: {
                type: 'number',
            },
            paddingHorizontal: {
                type: 'number',
            },
            paddingVertical: {
                type: 'number',
            },
            textFontSize: {
                type: 'number',
            },
            textFontWeight: {
                type: 'string',
            },
            textFontFamily: {
                type: 'string',
            },
            textColor: {
                type: 'string',
            },
            iconName: {
                type: 'string',
            },
            iconColor: {
                type: 'string',
            },
            iconWidth: {
                type: 'number',
            },
            iconHeight: {
                type: 'number',
            },
            iconMarginRight: {
                type: 'number',
            },
            hoverBorderColor: {
                type: 'string',
            },
            hoverBackgroundColor: {
                type: 'string',
            },
            activeBorderColor: {
                type: 'string',
            },
            activeBackgroundColor: {
                type: 'string',
            },
        },
        appearances: {
            outline: {
                default: true,
            },
            filled: {
                default: false,
            },
            subtle: {
                default: false,
            },
        },
        variantGroups: {
            status: {
                primary: {
                    default: false,
                },
                secondary: {
                    default: true,
                },
                success: {
                    default: false,
                },
                warning: {
                    default: false,
                },
                danger: {
                    default: false,
                },
                transparent: {
                    default: false,
                },
                white: {
                    default: false,
                },
            },
            size: {
                sm: {
                    default: false,
                },
                md: {
                    default: true,
                },
                lg: {
                    default: false,
                },
            },
        },
        states: {},
    },
    appearances: {
        outline: {
            mapping: {
                iconName: 'x',
                textFontWeight: 'bold',
                textFontFamily: 'text-font-family',
                textColor: '$color-white',
                iconColor: '$color-white',
                borderWidth: 1,
                borderRadius: 1000,
            },
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-ui2-brand-500',
                        iconColor: '$color-ui2-brand-500',
                        borderColor: '$color-ui2-brand-500',
                        backgroundColor: 'transparent',
                        hoverBorderColor: '$color-ui2-brand-500',
                        hoverBackgroundColor: '$color-ui2-brand-100',
                        activeBorderColor: '$color-ui2-brand-500',
                        activeBackgroundColor: '$color-ui2-brand-200',
                    },
                    secondary: {
                        textColor: '$color-ui2-neutral-400',
                        iconColor: '$color-ui2-neutral-400',
                        borderColor: '$color-ui2-neutral-400',
                        backgroundColor: 'transparent',
                        hoverBorderColor: '$color-ui2-neutral-400',
                        hoverBackgroundColor: '$color-ui2-neutral-100',
                        activeBorderColor: '$color-ui2-neutral-400',
                        activeBackgroundColor: '$color-ui2-neutral-200',
                    },
                    success: {
                        textColor: '$color-ui2-success-500',
                        iconColor: '$color-ui2-success-500',
                        borderColor: '$color-ui2-success-500',
                        backgroundColor: 'transparent',
                        hoverBorderColor: '$color-ui2-success-500',
                        hoverBackgroundColor: '$color-ui2-success-100',
                        activeBorderColor: '$color-ui2-success-500',
                        activeBackgroundColor: '$color-ui2-success-200',
                    },
                    warning: {
                        textColor: '$color-ui2-warning-500',
                        iconColor: '$color-ui2-warning-500',
                        borderColor: '$color-ui2-warning-500',
                        backgroundColor: 'transparent',
                        hoverBorderColor: '$color-ui2-warning-500',
                        hoverBackgroundColor: '$color-ui2-warning-100',
                        activeBorderColor: '$color-ui2-warning-500',
                        activeBackgroundColor: '$color-ui2-warning-200',
                    },
                    danger: {
                        textColor: '$color-ui2-danger-500',
                        iconColor: '$color-ui2-danger-500',
                        borderColor: '$color-ui2-danger-500',
                        backgroundColor: 'transparent',
                        hoverBorderColor: '$color-ui2-danger-500',
                        hoverBackgroundColor: '$color-ui2-danger-100',
                        activeBorderColor: '$color-ui2-danger-500',
                        activeBackgroundColor: '$color-ui2-danger-200',
                    },
                    transparent: {
                        textColor: '$color-ui2-neutral-transparent-64',
                        iconColor: '$color-ui2-neutral-transparent-64',
                        borderColor: '$color-ui2-neutral-transparent-64',
                        backgroundColor: 'transparent',
                        hoverBorderColor: '$color-ui2-neutral-transparent-64',
                        hoverBackgroundColor: '$color-ui2-neutral-transparent-8',
                        activeBorderColor: '$color-ui2-neutral-transparent-64',
                        activeBackgroundColor: '$color-ui2-neutral-transparent-16',
                    },
                    white: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-white',
                        backgroundColor: 'transparent',
                        hoverBorderColor: '$color-white',
                        hoverBackgroundColor: '$color-white-transparent-8',
                        activeBorderColor: '$color-white',
                        activeBackgroundColor: '$color-white-transparent-16',
                    },
                },
                size: {
                    sm: {
                        height: 16,
                        paddingHorizontal: 6,
                        paddingVertical: 0,
                        textFontSize: 11,
                        textFontWeight: 'bold',
                        iconWidth: 12,
                        iconHeight: 12,
                        iconMarginRight: 2,
                    },
                    md: {
                        height: 20,
                        paddingHorizontal: 8,
                        paddingVertical: 0,
                        textFontSize: 12,
                        textFontWeight: 'bold',
                        iconWidth: 16,
                        iconHeight: 16,
                        iconMarginRight: 4,
                    },
                    lg: {
                        height: 24,
                        paddingHorizontal: 10,
                        paddingVertical: 0,
                        textFontSize: 14,
                        textFontWeight: 'bold',
                        iconWidth: 20,
                        iconHeight: 20,
                        iconMarginRight: 4,
                    },
                },
            },
        },
        filled: {
            mapping: {
                iconName: 'x',
                textFontWeight: 'bold',
                textFontFamily: 'text-font-family',
                textColor: '$color-white',
                iconColor: '$color-white',
                borderWidth: 0,
                borderRadius: 1000,
            },
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-ui2-brand-500',
                        backgroundColor: '$color-ui2-brand-500',
                        hoverBorderColor: '$color-ui2-brand-600',
                        hoverBackgroundColor: '$color-ui2-brand-600',
                        activeBorderColor: '$color-ui2-brand-700',
                        activeBackgroundColor: '$color-ui2-brand-700',
                    },
                    secondary: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-ui2-neutral-400',
                        backgroundColor: '$color-ui2-neutral-400',
                        hoverBorderColor: '$color-ui2-neutral-500',
                        hoverBackgroundColor: '$color-ui2-neutral-500',
                        activeBorderColor: '$color-ui2-neutral-600',
                        activeBackgroundColor: '$color-ui2-neutral-600',
                    },
                    success: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-ui2-success-500',
                        backgroundColor: '$color-ui2-success-500',
                        hoverBorderColor: '$color-ui2-success-600',
                        hoverBackgroundColor: '$color-ui2-success-600',
                        activeBorderColor: '$color-ui2-success-700',
                        activeBackgroundColor: '$color-ui2-success-700',
                    },
                    warning: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-ui2-warning-500',
                        backgroundColor: '$color-ui2-warning-500',
                        hoverBorderColor: '$color-ui2-warning-600',
                        hoverBackgroundColor: '$color-ui2-warning-600',
                        activeBorderColor: '$color-ui2-warning-700',
                        activeBackgroundColor: '$color-ui2-warning-700',
                    },
                    danger: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-ui2-danger-500',
                        backgroundColor: '$color-ui2-danger-500',
                        hoverBorderColor: '$color-ui2-danger-600',
                        hoverBackgroundColor: '$color-ui2-danger-600',
                        activeBorderColor: '$color-ui2-danger-700',
                        activeBackgroundColor: '$color-ui2-danger-700',
                    },
                    transparent: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-ui2-neutral-transparent-64',
                        backgroundColor: '$color-ui2-neutral-transparent-64',
                        hoverBorderColor: '$color-ui2-neutral-transparent-72',
                        hoverBackgroundColor: '$color-ui2-neutral-transparent-72',
                        activeBorderColor: '$color-ui2-neutral-transparent-80',
                        activeBackgroundColor: '$color-ui2-neutral-transparent-80',
                    },
                    white: {
                        textColor: '$color-ui2-neutral-800',
                        iconColor: '$color-ui2-neutral-800',
                        borderColor: '$color-white',
                        backgroundColor: '$color-white',
                        hoverBorderColor: '$color-white-transparent-80',
                        hoverBackgroundColor: '$color-white-transparent-80',
                        activeBorderColor: '$color-white',
                        activeBackgroundColor: '$color-white',
                    },
                },
            },
        },
        subtle: {
            mapping: {
                iconName: 'x',
                textFontWeight: 'bold',
                textFontFamily: 'text-font-family',
                textColor: '$color-white',
                iconColor: '$color-white',
                borderWidth: 0,
                borderRadius: 1000,
            },
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-ui2-brand-500',
                        iconColor: '$color-ui2-brand-500',
                        borderColor: '$color-ui2-brand-100',
                        backgroundColor: '$color-ui2-brand-100',
                        hoverBorderColor: '$color-ui2-brand-200',
                        hoverBackgroundColor: '$color-ui2-brand-200',
                        activeBorderColor: '$color-ui2-brand-300',
                        activeBackgroundColor: '$color-ui2-brand-300',
                    },
                    secondary: {
                        textColor: '$color-ui2-neutral-500',
                        iconColor: '$color-ui2-neutral-500',
                        borderColor: '$color-ui2-neutral-100',
                        backgroundColor: '$color-ui2-neutral-100',
                        hoverBorderColor: '$color-ui2-neutral-200',
                        hoverBackgroundColor: '$color-ui2-neutral-200',
                        activeBorderColor: '$color-ui2-neutral-300',
                        activeBackgroundColor: '$color-ui2-neutral-300',
                    },
                    success: {
                        textColor: '$color-ui2-success-500',
                        iconColor: '$color-ui2-success-500',
                        borderColor: '$color-ui2-success-100',
                        backgroundColor: '$color-ui2-success-100',
                        hoverBorderColor: '$color-ui2-success-200',
                        hoverBackgroundColor: '$color-ui2-success-200',
                        activeBorderColor: '$color-ui2-success-300',
                        activeBackgroundColor: '$color-ui2-success-300',
                    },
                    warning: {
                        textColor: '$color-ui2-warning-500',
                        iconColor: '$color-ui2-warning-500',
                        borderColor: '$color-ui2-warning-100',
                        backgroundColor: '$color-ui2-warning-100',
                        hoverBorderColor: '$color-ui2-warning-200',
                        hoverBackgroundColor: '$color-ui2-warning-200',
                        activeBorderColor: '$color-ui2-warning-300',
                        activeBackgroundColor: '$color-ui2-warning-300',
                    },
                    danger: {
                        textColor: '$color-ui2-danger-500',
                        iconColor: '$color-ui2-danger-500',
                        borderColor: '$color-ui2-danger-100',
                        backgroundColor: '$color-ui2-danger-100',
                        hoverBorderColor: '$color-ui2-danger-200',
                        hoverBackgroundColor: '$color-ui2-danger-200',
                        activeBorderColor: '$color-ui2-danger-300',
                        activeBackgroundColor: '$color-ui2-danger-300',
                    },
                    transparent: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-ui2-neutral-transparent-40',
                        backgroundColor: '$color-ui2-neutral-transparent-40',
                        hoverBorderColor: '$color-ui2-neutral-transparent-48',
                        hoverBackgroundColor: '$color-ui2-neutral-transparent-48',
                        activeBorderColor: '$color-ui2-neutral-transparent-56',
                        activeBackgroundColor: '$color-ui2-neutral-transparent-56',
                    },
                    white: {
                        textColor: '$color-white',
                        iconColor: '$color-white',
                        borderColor: '$color-white-transparent-16',
                        backgroundColor: '$color-white-transparent-16',
                        hoverBorderColor: '$color-white-transparent-24',
                        hoverBackgroundColor: '$color-white-transparent-24',
                        activeBorderColor: '$color-white-transparent-32',
                        activeBackgroundColor: '$color-white-transparent-32',
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAChip.theme.alucio.js.map